import React from "react";

import { FormLabel } from "@impero-com/ui";

import { DraggableElementButton } from "./draggableElementButton";
import { ElementButton } from "./elementButton";
import * as theme from "./theme.css";
import { ElementButtonSpec } from "./types";

/**
 * The buttons panel, contains draggable buttons which can be dragged into sections to add elements to these sections.
 */
interface ButtonPanelProps<ElementButtonSpecId extends string> {
    panelTitle: string;
    panelTooltip?: string;
    headerAction?: React.ReactNode;
    buttonSpecs: Array<ElementButtonSpec<ElementButtonSpecId>>;
    draggable: boolean;
    children?: never;
}
export function ButtonPanel<ElementButtonSpecId extends string>({
    panelTitle,
    panelTooltip,
    headerAction,
    buttonSpecs,
    draggable,
}: ButtonPanelProps<ElementButtonSpecId>) {
    return (
        <div>
            <div className={theme.buttonPanel}>
                <div className={theme.contentPanelHeader}>
                    <FormLabel helpText={panelTooltip}>{panelTitle}</FormLabel>
                    <span className={theme.headerAction}>{headerAction}</span>
                </div>
                <div className={theme.buttons}>
                    {buttonSpecs.map((spec) =>
                        draggable ? (
                            <DraggableElementButton
                                key={spec.id}
                                icon={spec.icon}
                                id={spec.id}
                                label={spec.label}
                                onClick={spec.onClick}
                                renderPlaceholder={spec.renderPlaceholder}
                            />
                        ) : (
                            <ElementButton
                                key={spec.id}
                                draggable={false}
                                isDragging={false}
                                icon={spec.icon}
                                id={spec.id}
                                label={spec.label}
                                onClick={spec.onClick}
                                renderPlaceholder={spec.renderPlaceholder}
                            />
                        )
                    )}
                </div>
            </div>
        </div>
    );
}
